import { render, staticRenderFns } from "./domains.vue?vue&type=template&id=08e8ec88&"
import script from "./domains.vue?vue&type=script&lang=ts&"
export * from "./domains.vue?vue&type=script&lang=ts&"
import style0 from "./domains.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports